import { useCallback } from 'react'
import { TwinDictionary } from '../../../../../../../../../../../utils/globals/dictionary'


const useDataFromCPTME = () => {
    const beforeSubmitPrev = useCallback((vals: TwinDictionary) => {
        const { fontSize, background, padding, margin, justifyContent, alignItems, height, width, border, textAlign, color, fontWeight, fontSizeTicket, borderBottom, ...rest } = vals
        let myRest: TwinDictionary = {}
        for (const key in rest) {
            if (key.includes('[')) {
                const subKeys = key.split(/\[(\w*)\]+/).filter(function (e) { return e; });
                const value = rest[key]
                let item = myRest
                for (const key in subKeys) {
                    const element = subKeys[key]
                    if (parseInt(key) === subKeys.length - 1) {
                        item[element] = value
                        continue
                    }
                    if (!item[element]) {
                        item[element] = []
                    }
                    item = item[element]
                }
            } else {
                myRest[key] = rest[key]
            }
        }
        return {
            cssConfig: { fontSize, background, padding, margin, justifyContent, alignItems, height, width, border, textAlign, color, fontWeight, fontSizeTicket, borderBottom  },
            extraProps: { ...myRest }
        }
    }, [])

    return { beforeSubmitPrev }
}

export default useDataFromCPTME